<template>
  <div id="app">
    
    <header class="officialHeader">
      <div class="officialName">
        <img src="../static/hometitle.png" alt="">
      </div>
      <div class="officialNav">
        <ul>
          <li><router-link class="routerLink" to="/home" exact>首页</router-link></li>
          <li><router-link class="routerLink" to="/productionShow">软件产品</router-link></li>
          <!--          <li><router-link class="routerLink" to="community">硬件设备</router-link></li>-->
          <li><router-link class="routerLink" to="/news">新闻动态</router-link></li>
          <li><router-link class="routerLink" to="/contactUs">关于我们</router-link></li>
          <!-- <li><a id="wzayd" title="网站信息无障碍工具条" href="javascript:;" class="wzayd" accesskey="g">无障碍阅读</a></li> -->
          <li><a id="assist-open">无障碍阅读</a></li>
        </ul>
      </div>
    </header>
    <keep-alive>
      <router-view style="float: left"></router-view>
    </keep-alive>
  </div>
</template>
<script type=text/javascript src=/static/js/jquery-3.7.1.min.js></script>
<!-- <script id="rrbayJs" src="/canyou/js/wza.min.js" referrerpolicy="origin"></script> -->
<script src="//js.tagalta.com/tagalta/js/tagalta.wza1.0.js" type="text/javascript"></script>
<script>
  export default {
    name: 'app',
    data() {
      return {}
    },
    mounted() {
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      }); /*页面跳转回到顶部*/
    }
  }
</script>

<style scoped>
  .officialHeader {
    height: 110px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .officialName {
    display: inline-block;
    font-size: 1.5rem;
    font-weight: bold;
  }

  .officialNav {
    flex-grow: 1;
    display: flex;
    align-items: center;
  }

  .officialNav ul {
    display: flex;
    list-style: none;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
  }

  .officialNav ul li {
    display: inline-block;
    height: 2.5rem;
    font-size: 1.5rem;
    margin-right: 4%;

  }

  .routerLink {
    color: rgba(80, 80, 80, 1);
  }

  .routerLink:hover {
    color: rgba(59, 179, 196, 1);
  }

  .router-link-active {
    color: rgba(59, 179, 196, 1);
  }

  @media only screen

  /*iphone*/
  and (min-width: 320px) and (max-width: 922px) {
    .officialHeader {
      height: 180px;
      flex-direction: column;
      align-items: center;
    }

    .officialName {
      margin: 20px 0 0 0;
    }

    .officialNav {
      width: 100%;
    }

    .officialNav ul {
      justify-content: center;
      flex-wrap: wrap;
    }

    .officialNav ul li {
      margin: 0 2%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue